import { useExternalTicketsHeadline } from './hooks/useExternalTicketsHeadline';
import { ExternalTicketsPanelCta } from './ExternalTicketsPanelCta';
import { ExternalTicketsPanelDate } from './ExternalTicketsPanelDate';
import { ExternalTicketsPanelHeadline } from './ExternalTicketsPanelHeadline';
import styles from './ExternalTicketsPanel.module.scss';

export const ExternalTicketsPanel: React.FC = () => {
  const { isExternalTicketingInformationAvailable } = useExternalTicketsHeadline();

  if (!isExternalTicketingInformationAvailable) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="external-tickets-panel">
      <div className={styles.content}>
        <ExternalTicketsPanelHeadline />
        <ExternalTicketsPanelDate />
      </div>
      <ExternalTicketsPanelCta />
    </div>
  );
};
